import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=6d2db429"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
script.render = render

export default script